let getMontoEnMoneda = function(monto) {
  let numero = monto;
  let negativo = false;
  if (monto < 0) {
    negativo = true;
    numero = numero
      .toString()
      .replace(/\./g, "")
      .substring(1);
  }
  numero = numero
    .toString()
    .split("")
    .reverse()
    .join("")
    .replace(/(?=\d*\.?)(\d{3})/g, "$1.");
  numero = numero
    .split("")
    .reverse()
    .join("")
    .replace(/^[\.]/, "");
  if (negativo) {
    numero = "-" + numero;
  }
  return "$ " + numero;
};

let getFormatoNumerico = function(valor) {
  /*let numero = valor;
  numero = numero
    .toString()
    .split("")
    .reverse()
    .join("")
    .replace(/(?=\d*\.?)(\d{3})/g, "$1.");
  numero = numero
    .split("")
    .reverse()
    .join("")
    .replace(/^[\.]/, "");
*/
  return new Intl.NumberFormat("de-CL").format(valor);
};

let getArancelMatriculaFormateado = function(monto, tipoMoneda) {
  if (tipoMoneda === "CLP") {
    return this.getMontoEnMoneda(monto);
  } else {
    return `${tipoMoneda} ${this.getFormatoNumerico(monto)} `;
  }
};

export default {
  getMontoEnMoneda,
  getFormatoNumerico,
  getArancelMatriculaFormateado
};



// WEBPACK FOOTER //
// ./src/utils/FormatoMonetario.js